<template>
  <div class="error-box">
    <img src="../../assets/images/404.jpg" />
    <p>您请求的页面不存在！</p>
    <el-button
      @click="checkToIndex"
      type="danger"
    >
      返回首页
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'ErrorIndex',
  data() {
    return {

    };
  },
  methods: {
    checkToIndex() {
      this.$router.push(this.contextPath + "/")
    }
  }
};
</script>

<style scoped lang="scss">
.error-box {
  text-align: center;
  h1 {
    color: #000;
    font-size: 100px;
    margin-top: 100px;
  }
  p {
    font-size: 30px;
    line-height: 30px;
    margin-bottom: 20px;
  }
  & /deep/.el-button--danger {
    background: #bb0b0b;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/error/Error.vue